// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"beo_a bhl_tr","StrollerBoxWidget__imageCounselling":"beo_b bhl_kg"};